// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Samoa from '../_raw/flag/icon_flag_samoa.png';

export default () => <img src={Samoa} alt="Samoa" />;
